
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-streaming-demo-typing","docs-x-markdown-streaming-demo-format","docs-x-markdown-streaming-demo-animation"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.en-US.md?type=demo')
};